import React from 'react';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { Col } from 'reactstrap';
import SystemLabel from '../../../../../system/SystemLabel/SystemLabel';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton } from '@material-ui/core';
import SpeakerTabs from './SpeakerTabs';
import SpeakerTimer from './SpeakerTimer'


export default function SpeakerOverview(props) {
    const activeSpeaker = props.speakers && props.speakers.find(s => s.active === true)

    return (
        <Card className="dark-card" style={{ margin: 10, height: 'calc(100% - 10px)' }}>
            <div style={{ width: '100%', padding: '0px 10px', paddingTop: 15, display: 'inline-flex' }}>
                <Col className="col-6 text-left">
                    <Typography className="primary-text" variant="h6">
                        <SystemLabel name={'SpeakersFor'} />:
                    </Typography>
                    <div className="dark-list" style={{ color: '#FFFFFF99', fontSize: '16px', maxHeight: '125px', overflowY: 'auto' }} dangerouslySetInnerHTML={{ __html: props.agendaSpeakers ? props.agendaSpeakers.name : '' }}>

                    </div>
                </Col>
                <Col className="col-6 text-right">
                  {/*   {activeSpeaker ?
                        <SpeakerTimer
                            hubConnection={props.hubConnection}
                            timeout={activeSpeaker.duration}
                        />
                        : null} */}
                </Col>
            </div>
            <CardContent style={{ minHeight: 'calc(100% - 40px)', maxHeight: 'calc(100% - 40px)', }}>
                <SpeakerTabs {...props} />
            </CardContent>
        </Card>


    );
}